<template>
  <div>
    <div
      v-if="
        transaction &&
        transaction['status'] != -1 &&
        transaction['client_confirmed'] &&
        transaction['system_confirmed']
      "
    >
      <h4>
        {{
          "order_done_byyer_make_product"
            | setText("Заказ успешно оплачен! Клиент может забрать товар")
        }}
      </h4>
    </div>
    <div v-else-if="transaction && transaction['status'] == -1">
      <h4>{{ "order_canceled" | setText("Заказ отменен") }}</h4>
    </div>
    <div
      v-else-if="
        transaction &&
        transaction['client_confirmed'] &&
        !transaction['system_confirmed']
      "
    >
      <h3 class="text-danger">
        {{
          "order_waiting_pay"
            | setText(
              " Заказ в ожидании оплаты. Товар клиенту передавать нельзя!"
            )
        }}
      </h3>

      <h4>
        {{
          "go_to_tg"
            | setText(
              "Дальнейшую инструкцию ожидайте в общей чат-группе телеграм"
            )
        }}}
      </h4>

      <button @click="check" class="btn btn-info">
        {{ "check_pay_status" | setText("Проверить статус оплаты") }}
      </button>
    </div>

    <div class="install-control">
      <div v-if="transaction && transaction['api_result']">
        <ul>
          <li>
            {{ "order_number" | setText("Номер заказа") }}:
            {{ transaction["exchange_additional_id"] }}
          </li>
          <li>
            {{ "order_number" | setText("Номер заказа") }} (API):
            {{ transaction["exchange_id"] }}
          </li>
          <li>
            {{ "price" | setText("Цена") }}:
            {{ transaction["api_result"]["data"]["price"] / 100 }} UZS
          </li>
          <li>
            {{ "pay_month" | setText("Оплата в месяц") }}:
            {{ transaction["api_result"]["data"]["per_month_amount"] / 100 }}
            UZS
          </li>
          <li>
            {{ "period" | setText("Срок") }}:
            {{ transaction["api_result"]["data"]["duration"] }} м.
          </li>
          <li>
            {{ "total" | setText("Итого") }}:
            {{ transaction["api_result"]["data"]["installment_price"] / 100 }}
            UZS
          </li>
        </ul>
        <Br />
        <code>
          {{ transaction["api_result"] }}
        </code>
      </div>
    </div>
    <button
      v-if="
        $store.state['user']['is_root'] &&
        transaction &&
        transaction['status'] != -1
      "
      @click="cancel"
      class="btn btn-danger"
    >
      {{ "cancel_order" | setText("Отменить заказ") }}
    </button>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    hash: {
      default: null,
    },
    buyer: {
      default: 0,
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    cancel() {
      this.$loading(true);

      logger(this.$http, {
        name: "Отмена заказа в #INTEND",
        description: "",
        model_type: "order",
        model_id: this.order.id,
      });

      this.createTransaction({
        status: -1,
      });
    },
    check() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}order/check`,
        method: "POST",
        data: {
          ref_id: this.transaction["exchange_id"],
        },
        headers: {
          "api-key": `${this.partner["api_public_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.hash}`,
        },
      })
        .then((response) => {
          if (response.data.data) {
            const partner_status = response.data.data.status;
            if (partner_status == 1 || partner_status == 3) {
              this.message = "Заказ не не оплачен";
            } else if (partner_status == 2) {
              this.message = "Заказ успешно оплчен";
              this.createTransaction({
                client_confirmed: 1,
                system_confirmed: 1,
                exchange_additional_id: response.data.data.order_id,
              });
            }
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          } else {
            this.message = "Статус не пришел от партнера";
          }

          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Проверка статуса оплаты #INTEND",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
    };
  },
};
</script>
<style lang="scss">
</style>
